(function () {
    'use strict';

    angular.module('chilliAuth', [
        // Angular modules 
        'ngRoute',

        // Custom modules 

        // 3rd Party Modules
        'auth0.lock',
        'angular-storage',
        'angular-jwt'
    ]);

    /**
     * Bootstrap settings for Auth0.
     */
    angular.module('chilliAuth').config(['lockProvider', 'chilliAuthConstants', function myAppConfig(lockProvider, chilliAuthConstants) {
        lockProvider.init({
            domain: chilliAuthConstants.DOMAIN,
            clientID: chilliAuthConstants.CLIENT_ID,
            loginUrl: chilliAuthConstants.LOGIN_URL,
            options: {
                theme: {
                    logo: 'Images/ChilliDocs-Login-Logo.png'
                },
                closable: false,
                avatar: null,
                auth: {
                    redirect: false,
                    params: {
                        scope: chilliAuthConstants.AUTH_SCOPE
                    }
                }
            }
        });
    }]);

    /**
     * Auth0 event handlers.
     */
    angular.module('chilliAuth').run(['lock', 'store', '$rootScope', function myAppConfig(lock, store, $rootScope) {
        lock.on('authenticated', function (authResult) {
            lock.hide();
            store.remove('profile');
            store.set('token', authResult.idToken);

            lock.getProfile(authResult.accessToken, function (error, profile) {
                if (error) {
                    console.error(error);
                } else {
                    $rootScope.profile = profile;
                    store.set('profile', profile);
                    $rootScope.$emit('chilliAuth:login');
                    appInsights.setAuthenticatedUserContext(store.get('profile').name);
                }
            });
        });
    }]);

    /**
     * Register HTTP interceptors for JWT auth token injection and for showing login if user is not authenticated.
     */
    angular.module('chilliAuth').config(['$httpProvider', 'jwtInterceptorProvider', function ($httpProvider, jwtInterceptorProvider) {
        jwtInterceptorProvider.tokenGetter = ['store', function (store) {
            return store.get('token');
        }];

        $httpProvider.interceptors.push('loginInterceptor');
        $httpProvider.interceptors.push('jwtInterceptor');
    }]);

    /**
     * On route change, if user is not authenticated, show login.
     */
    angular.module('chilliAuth').run(['$rootScope', 'ChilliAuthService', function ($rootScope, ChilliAuthService) {
        $rootScope.$on('$routeChangeStart', function (event, next) {
            if (!ChilliAuthService.isAuthenticated) {
                ChilliAuthService.showLogin();
            }
        });
    }]);


    ///**
    // * On location change, validate auth token, including expiration. If user is not authenticated, show login.
    // */
    //angular.module('chilliAuth').run(['$rootScope', 'auth', 'store', 'jwtHelper', 'ChilliAuthService', function ($rootScope, auth, store, jwtHelper, ChilliAuthService) {
    //    $rootScope.$on('$locationChangeStart', function (event, next, current) {
    //        var token = store.get('token');
            
    //        if (token) {
    //            if (!jwtHelper.isTokenExpired(token)) {
    //                if (!auth.isAuthenticated) {
    //                    // Re-authenticate with the user's profile
    //                    // Calls authProvider.on('authenticated')
    //                    auth.authenticate(store.get('profile'), token);
    //                    appInsights.setAuthenticatedUserContext(store.get('profile').name);
    //                }
    //            } else {
    //                // Have to signout of auth service because an expired token doesn't automatically do this.
    //                auth.signout();
    //                ChilliAuthService.showLogin();
    //            }
    //        }
    //    });
    //}]);
})();
